//client/src/components/LanguageToggle.tsx
import { Languages } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext.tsx";

interface LanguageToggleProps {
  className?: string;
}

export default function LanguageToggle({ className }: LanguageToggleProps) {
  const { language, setLanguage } = useLanguage();

  const defaultClassName = "flex items-center gap-2 px-4 h-9 text-sm font-medium text-gray-700 transition-colors bg-white border border-gray-300 rounded-full hover:bg-gray-50";

  return (
    <div className="relative">
      <button
        onClick={() => setLanguage(language === "en" ? "st" : "en")}
        className={className || defaultClassName}
        title={
          language === "en" ? "Switch to Sesotho" : "Fetohela ho Senyesemane"
        }
      >
        <Languages className="w-4 h-4" />
        <span className="font-semibold whitespace-nowrap">
          {language === "en" ? "English" : "Sesotho"}
        </span>
      </button>
    </div>
  );
}
